<div class="coluna" [class.inativa]="!processo.isAtivo">
  <div class="coluna-header">
    <span class="proc-icone" [class.off]="!processo.isAtivo">
      <mat-icon class="material-symbols-outlined">{{ tipoIcone }}</mat-icon>
    </span>
    <div class="proc-info">
      <div class="proc-nome">{{ processo.descricaoTipo }}</div>
      <div class="proc-sub">{{ subtitulo }} · {{ qtdEtapaFluxoPrincipal }} etapa(s)</div>
    </div>
    @if (isObrigatorio) {
    <span class="badge-obrigatorio">Obrigatório</span>
    } @else {
    <div class="toggle-wrap">
      <mat-slide-toggle [checked]="processo.isAtivo" (change)="onToggle($event)" color="primary"></mat-slide-toggle>
      <span class="toggle-label">{{ processo.isAtivo ? 'Ativo' : 'Inativo' }}</span>
    </div>
    }
  </div>

  <div class="coluna-body">
    @for (secao of secoes; track secao.idTipoEtapaKanban) {
    <section class="kb-secao">
      <div class="kb-secao-head">
        <mat-icon class="material-symbols-outlined kb-secao-ic">{{ secao.nomeIcone }}</mat-icon>
        <span class="kb-secao-titulo">{{ secao.titulo }}</span>
      </div>
      @if (secao.textoApoio) {
      <p class="kb-secao-apoio">{{ secao.textoApoio }}</p>
      }

      <!-- Só o fluxo principal é reordenável; especiais e marcadores ficam fora do arraste. -->
      <div class="kb-secao-lista" cdkDropList [cdkDropListDisabled]="!processo.isAtivo || !secao.isFluxoPrincipal"
        [cdkDropListSortPredicate]="podeSoltarNaPosicao" (cdkDropListDropped)="drop($event)">
        @for (s of secao.etapas; track s.idEtapaKanban) {
        <div class="etapa-card" cdkDrag [cdkDragDisabled]="!processo.isAtivo || s.isFixo"
          [attr.id]="'etapa-kanban-' + s.idEtapaKanban" [style.--k-dot]="cor(s.idKanbanCor)?.corPrincipal"
          [style.--k-dot-dark]="cor(s.idKanbanCor)?.corPrincipalDark" [style.--k-bg]="cor(s.idKanbanCor)?.corFundo"
          [style.--k-bg-dark]="cor(s.idKanbanCor)?.corFundoDark" [style.--k-fg]="cor(s.idKanbanCor)?.corConteudo"
          [style.--k-fg-dark]="cor(s.idKanbanCor)?.corConteudoDark">

          <!-- Etapa fixa troca a alça de arraste por um cadeado. -->
          @if (s.isFixo) {
          <div class="drag-handle fixo" matTooltip="Etapa fixa do sistema — nome e posição não podem ser alterados">
            <mat-icon class="material-symbols-outlined">lock</mat-icon>
          </div>
          } @else {
          <div class="drag-handle" cdkDragHandle matTooltip="Arraste para reordenar">
            <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
          </div>
          }

          <span class="etapa-icone">
            <mat-icon class="material-symbols-outlined">{{ iconeNome(s.idKanbanIcone) }}</mat-icon>
          </span>

          <div class="etapa-info">
            <div class="etapa-nome-linha">
              <span class="etapa-nome">{{ s.nome }}</span>
              @if (s.isFixo) {
              <span class="badge-fixo"><mat-icon class="material-symbols-outlined">lock</mat-icon> FIXO</span>
              }
            </div>

            @if (s.descricao) {
            <p class="etapa-apoio">{{ s.descricao }}</p>
            }

            <div class="etapa-meta">
              @if (s.isInicial) {
              <span class="meta meta-ini"><mat-icon class="material-symbols-outlined">play_circle</mat-icon> Inicial</span>
              }
              @if (s.isFinal) {
              <span class="meta meta-fin"><mat-icon class="material-symbols-outlined">flag</mat-icon> Final</span>
              }
              @if (secao.isFluxoPrincipal) {
              <span class="meta">
                <mat-icon class="material-symbols-outlined">route</mat-icon>
                {{ s.movimentacoes.length }} destino(s)
              </span>
              }
              <span class="meta">
                <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                {{ s.idsPerfilVisibilidade.length ? (s.idsPerfilVisibilidade.length + ' perfil(is)') : 'todos' }}
              </span>
              @if (s.isMotivoObrigatorio) {
              <span class="chip-motivo" [matTooltip]="tooltipMotivo(s)">
                <mat-icon class="material-symbols-outlined">edit_note</mat-icon> exige motivo
              </span>
              }
            </div>
          </div>

          <!-- A edição só acontece pelo menu; clicar no corpo do card não abre mais nada. -->
          <button mat-icon-button type="button" class="etapa-menu" [matMenuTriggerFor]="menuEtapa"
            matTooltip="Mais opções">
            <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
          </button>
          <mat-menu #menuEtapa="matMenu">
            <button mat-menu-item type="button" (click)="editar.emit(s)">
              <mat-icon class="material-symbols-outlined">edit</mat-icon> <span>Editar</span>
            </button>
            @if (!s.isFixo) {
            <button mat-menu-item type="button" (click)="excluir.emit(s)">
              <mat-icon class="material-symbols-outlined">delete</mat-icon> <span>Excluir</span>
            </button>
            }
          </mat-menu>
        </div>
        }
      </div>

      @if (secao.isFluxoPrincipal && processo.isAtivo) {
      <button type="button" class="btn-add-etapa" (click)="adicionar.emit()">
        <mat-icon class="material-symbols-outlined">add</mat-icon> Adicionar etapa
      </button>
      }
    </section>
    }

    @if (!processo.isAtivo) {
    <button type="button" class="btn-add-etapa reativar" (click)="ativarProcesso()">
      <mat-icon class="material-symbols-outlined">toggle_on</mat-icon> Ativar processo
    </button>
    }
  </div>
</div>